export const Permissions = Object.freeze({
  MANAGE_TOURNAMENTS: 'manage_tournaments',
  MANAGE_NEWS: 'manage_news',
  MANAGE_RANKING: 'manage_ranking',
  VIEW_PLAYER_DETAILS: 'view_player_details',
  MEMBER_ACTIONS: 'member_actions',
  MANAGE_PLAYER_TOURNAMENT_ENROLMENT: 'manage_player_tournament_enrolment',
  MANAGE_CLUB_MEMBERS: 'manage_club_members',
  MANAGE_APP_SECURITY: 'manage_app_security',
});
